import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('sidebar');
  return (
    <p style={{ fontSize: 12 }} className=" text-center text-gray-700 sm:!mb-0 md:text-base">
      ©{1900 + new Date().getYear()} {t('footer_text')}
    </p>
  );
};

export default Footer;
